import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_VEHICLE_SERVICES_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required('Molimo Vas da unesite naziv'),
  ratePerKm: yup.string().required('Molimo Vas da unesite koeficijent'),
});

